module.exports = __webpack_public_path__ + "img/xinzhuang-4.dcc71305.jpg";